import React, { Component } from "react"
import { FaAngleRight } from "react-icons/fa"

import Nav from "./nav"
// import HeaderPhone from "./HeaderPhone"
import FrontCard from "../images/trc-front-card.png"
import RightOffer from "../images/right_offer.png"
import LeftOffer from "../images/left_offer.png"

export default class Header extends Component {
  render() {
    return (
      <>
        <Nav />
        <header class="header lg:px-0 px-8 pb-24">
          <div class="container mx-auto">
            <div class="header-section flex-wrap">
              <div class="order-last lg:order-first lg:w-1/2 w-full flex flex-col justify-center text-center lg:text-left header-section_content">
                <h1 className="lg:text-5xl text-4xl leading-normal">
                  Enjoy <span className="bold">exclusive deals</span> on
                  <span className="bold"> your favourite stores.</span>
                </h1>
                <p className="lg:text-xl text-base">
                  Enjoy great deals on your favourite stores around the city.
                </p>
                <ul className="header-buttons justify-center lg:justify-start">
                  <li>
                    <a href="#" class="btn  lg:mr-5 md:mr-5 sm:mr-0">
                      get your card &nbsp; &nbsp;
                      <FaAngleRight />
                    </a>
                  </li>
                  <li>
                    <a href="#" class="btn download-app">
                      download App
                    </a>
                  </li>
                </ul>
              </div>
              <div class="lg:w-1/2 w-full header-section_image ">
                <img src={FrontCard} alt="" />
              </div>
            </div>
          </div>
        </header>
      </>
    )
  }
}
